import React from "react";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { IAppEntity } from "../../entities";
import SetItemsPricesDetails from "../../../components/Pages/Documents/SetItemPrices/SetItemsPricesDetails";
import SetItemsPricesList from "../../../components/Pages/Documents/SetItemPrices/SetItemsPricesList";
import { NFLookupSetItemsPrices } from "../../../components/Shared/NewForms/NFLookupSetItemsPrices";
import { SetItemsPricesService } from "../../../services/documents/SetItemsPricesService";
import { CreateSetItemsPricesDto } from "../../../dtos/documents/SetItemsPrices/CreateSetItemsPricesDto";
import { stringify } from "querystring";

export const SetItemsPrices: IAppEntity = {
  entityType: "document",
  title: "Set Items Prices",
  pluralTitle: "Set Items Prices",
  apiUrl: "SetItemsPrices",
  apiEnum: ReferenceTypes.DocumentSetItemsPrice,
  getDetailViewComponent: (
    model: any,
    modelUpdatedEvent: (model: any) => void
  ) =>
    React.createElement(SetItemsPricesDetails, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(SetItemsPricesList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupSetItemsPrices, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService: () => new SetItemsPricesService("SetItemsPrices"),
  getEmptyModel: () => {
    const model: CreateSetItemsPricesDto = {
      totalAmount: 0,
      totalAmountVat: 0,
      status: 0,
      
      documentDate: new Date(),
      createdDate: new Date(),
      products: [],
    };
    return model;
  },
};
